<script>
  import { checkbox } from 'vue-strap';
  
  export default {
    components: {checkbox},
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    computed: {
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      }
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <div class="form-group" :class="{'has-error': errors.has('quantidade'), 'required': configuracao.obrigatorioQuantidadeSolicitacaoCompraItemLivros}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="`${configuracao.obrigatorioQuantidadeSolicitacaoCompraItemLivros ? 'required|' : ''}not_zero`"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6">
                <div class="form-group required" :class="{'has-error': errors.has('titulo')}">
                    <label class="control-label" for="titulo">Descrição</label>

                    <input type="text"
                           class="form-control"
                           id="titulo"
                           v-model="itemSolicitacao.descricao"
                           v-validate="'required'"
                           data-vv-name="titulo"
                           data-vv-as="descrição">

                    <p class="text-danger" v-show="errors.has('titulo')">{{ errors.first('titulo') }}</p>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group" :class="{'has-error': errors.has('isbn'), 'required': configuracao.obrigatorioIsbnSolicitacaoCompraItemLivros}">
                    <label class="control-label" for="isbn">ISBN</label>

                    <input type="text"
                           class="form-control"
                           id="isbn"
                           v-model="itemSolicitacao.isbn"
                           v-validate="`${configuracao.obrigatorioIsbnSolicitacaoCompraItemLivros ? 'required' : ''}`"
                           data-vv-name="isbn"
                           data-vv-as="isbn"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('isbn')">{{ errors.first('isbn') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6">
                <div class="form-group">
                    <label class="control-label" for="autor">Autor</label>

                    <input type="text"
                           class="form-control"
                           id="autor"
                           v-model="itemSolicitacao.autor"
                           maxlength="100">
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group">
                    <label class="control-label" for="editora">Editora</label>

                    <input type="text"
                           class="form-control"
                           id="editora"
                           v-model="itemSolicitacao.editora"
                           maxlength="60">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-4">
                <div class="form-group">
                    <label class="control-label" for="edicao">Edição</label>

                    <input type="text"
                           class="form-control"
                           id="edicao"
                           v-model="itemSolicitacao.edicao"
                           maxlength="30">
                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group">
                    <label class="control-label" for="volume">Volume</label>

                    <input type="text"
                           class="form-control"
                           id="volume"
                           v-model="itemSolicitacao.volume"
                           maxlength="30">
                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group">
                    <label class="control-label" for="exemplar">Exemplar</label>

                    <input type="text"
                           class="form-control"
                           id="exemplar"
                           v-model="itemSolicitacao.exemplar"
                           maxlength="30">
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormLivros.vue